module.exports = __webpack_public_path__ + "static/media/500.3098f2c4.svg";